import { makeStyles } from "@material-ui/core/styles";
import {
  warning,
  error,
  secondary,
  white,
} from "../../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: `0 ${theme.spacing(5)}px ${theme.spacing(2.5)}px ${theme.spacing(
      5
    )}px `,
  },
  icon: {
    color: error,
    width: theme.spacing(7.5),
    height: theme.spacing(7.5),
    marginBottom: theme.spacing(5),
  },
  warning: {
    color: warning,
  },
  textSeparation: {
    paddingBottom: theme.spacing(2),
  },
  button: {
    height: theme.spacing(5),
    borderRadius: 20,
  },
  outlinedButton: {
    borderColor: secondary,
    marginRight: theme.spacing(2),
    color: secondary,
  },
  containedButton: {
    backgroundColor: secondary,
    "&:hover": {
      backgroundColor: secondary,
    },
    color: white,
  },
  progress: {
    color: theme.palette.grey[500],
    marginRight: theme.spacing(1),
  },
}));

export default useStyles;
